(ns splash.ui.lender-portal.routes
  (:require
    ["react-router-dom" :refer [Route Switch]]
    [splash.ui.lender-portal.views.pages.application :as application]
    [splash.ui.lender-portal.views.pages.document-viewer :as document-viewer]
    [splash.ui.lender-portal.views.pages.documents :as documents]
    [splash.ui.lender-portal.views.pages.search :as search]))

(defn v1
  []
  [:> Switch
   [:> Route {:path "/" :exact true}
    [search/view]]
   [:> Route {:path "/search" :exact true}
    [search/view]]
   [:> Route {:path "/application/:applicationId" :exact true}
    [application/view]]
   [:> Route {:path "/application/:applicationId/documents" :exact true}
    [documents/view]]
   [:> Route {:path "/application/:applicationId/documents/:documentId" :exact true}
    [document-viewer/view]]])
